<div class="dialog">
  <div class="composition">
    <div class="title title-margin-top">
      <h3>{{ 'dialog_complex_product_title' | translate }}</h3>
    </div>
    <div>
      <mat-accordion hideToggle>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="row text-bold">
                <div class="col-1 text-center"></div>
                <div class="col-1 text-center">{{ 'common_field_code' | translate }}</div>
                <div class="col-2 text-center">{{ 'common_field_label' | translate }}</div>
                <div class="col-2 text-center">{{ 'common_field_transport' | translate }}</div>
                <div class="col-1 text-center">{{ 'common_field_energy' | translate }}</div>
                <div class="col-1 text-center">{{ 'common_field_distance' | translate }}</div>
                <div class="col-1 text-center">{{ 'dialog_complex_product_col_double_freight' | translate }}</div>
                <div class="col-2 text-center">{{ 'dialog_complex_product_col_work_unit' | translate }}</div>
                <div class="col-1 text-center">{{ 'common_field_quantity' | translate }}</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngIf="currentItem?.productsComposition && currentItem?.productsComposition?.length">
            <div class="row" [ngClass]="{ backgroundColor: indexPro % 2 == 0 }" *ngFor="let item of currentItem?.productsComposition; let indexPro = index">
              <div class="col-1 text-center">
                <badge-statut itemType="blue"></badge-statut>
              </div>
              <div class="col-1 text-center">
                {{ item.code }}
              </div>
              <div class="col-2 text-center">
                {{ item.displayName }}
              </div>
              <div class="col-2 text-center">
                <span
                  >{{ item.transportName ? item.transportName : ('common_no_transport' | translate) }}
                  <mat-icon class="transport-deleted" [matTooltip]="'project_error_transport_deleted' | translate: { name: item.transportName }" *ngIf="item.transportDeleted">error </mat-icon>
                </span>
              </div>
              <div class="col-1 text-center">
                <div>
                  {{ item?.energyName ? item?.energyName : ('common_no_energy' | translate) }}
                </div>
              </div>
              <div class="col-1 text-center">
                <div>
                  {{ item.distance }}
                </div>
              </div>
              <div class="col-1 text-center">
                <div>
                  <mat-checkbox [checked]="item?.doubleCargo ? true : false" (change)="item.doubleCargo = !item?.doubleCargo" disabled> </mat-checkbox>
                </div>
              </div>
              <div class="col-2 text-center">
                {{ item.productWorkUnit }}
              </div>
              <div class="col-1 text-center">
                {{ item.quantity }}
              </div>
            </div>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
